import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ebfb763c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { ref } from "vue";
import { ElMessage } from "element-plus";
import { Plus } from "@element-plus/icons-vue";
import { UploadUrl } from "@/utils/request";
import type { UploadProps } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const imageUrl = ref("");

const handleAvatarSuccess: UploadProps["onSuccess"] = (response, uploadFile) => {
  imageUrl.value = URL.createObjectURL(uploadFile.raw!);
  console.log(imageUrl.value);
};

const beforeAvatarUpload: UploadProps["beforeUpload"] = (rawFile) => {
  if (rawFile.type !== "image/jpeg") {
    ElMessage.error("Avatar picture must be JPG format!");
    return false;
  } else if (rawFile.size / 1024 / 1024 > 2) {
    ElMessage.error("Avatar picture size can not exceed 2MB!");
    return false;
  }
  return true;
};

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createBlock(_component_el_upload, {
    class: "avatar-uploader",
    action: _unref(UploadUrl),
    "show-file-list": false,
    "on-success": handleAvatarSuccess,
    "before-upload": beforeAvatarUpload
  }, {
    default: _withCtx(() => [
      (imageUrl.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: imageUrl.value,
            class: "avatar"
          }, null, 8, _hoisted_1))
        : (_openBlock(), _createBlock(_component_el_icon, {
            key: 1,
            class: "avatar-uploader-icon"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Plus))
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 8, ["action"]))
}
}

})